var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 110,
    viewBox: "0 0 108 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6635 84.327C68.8076 84.327 84.327 68.8076 84.327 49.6635C84.327 30.5194 68.8076 15 49.6635 15C30.5194 15 15 30.5194 15 49.6635C15 68.8076 30.5194 84.327 49.6635 84.327Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6635 77.9437C65.2823 77.9437 77.9437 65.2822 77.9437 49.6635C77.9437 34.0447 65.2823 21.3832 49.6635 21.3832C34.0448 21.3832 21.3833 34.0447 21.3833 49.6635C21.3833 65.2822 34.0448 77.9437 49.6635 77.9437Z",
    fill: "#C1E8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6636 30.2493V49.6635H65.4785",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8291 95C84.8697 95 93.0092 86.8605 93.0092 76.8199C93.0092 66.7792 84.8697 58.6397 74.8291 58.6397C64.7885 58.6397 56.6489 66.7792 56.6489 76.8199C56.6489 86.8605 64.7885 95 74.8291 95Z",
    fill: "#0C57BF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8145 69.0117V78.2744",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8145 84.6282H74.8376",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.cad4a65865a7cde9a65f9dc9c5a3f572.svg";
export { ForwardRef as ReactComponent };